<script>
import Template from '{Template}/Web/Pages/Wallet/Wallets.template'
import AppLayout from '@/Layouts/AppLayout'
import JetCheckbox from '@/Jetstream/Checkbox'
import TableFilter from "@/Mixins/Filter/TableFilter";
import IconFilter from "@/Components/Table/IconFilter";

export default Template({
    components: {
        AppLayout,
        JetCheckbox,
        TableFilter,
        IconFilter
    },
    mixins: [TableFilter],
    mounted() {

        this.setFilter('balance_in_wallet', 'desc', true);

        if(_.isEmpty(this.wallets)) {
            this.$store.dispatch('fetchWallets');
        }
    },
    computed: {
        wallets: function () {

            let wallets = _.orderBy(this.$store.getters.getWallets, (wallet) => {

                if(this.filter.filterBy == 'symbol' || this.filter.filterBy == 'type') {
                    return wallet[this.filter.filterBy];
                } else {
                    return parseFloat(wallet[this.filter.filterBy]);
                }

            }, this.filter.filterDirection == 'desc' ? 'desc' : 'asc');

            return _.filter(wallets, (wallet) => {
                let sortedBy = true;

                if(this.filter.sortBy == "balance") {
                    sortedBy = parseFloat(wallet.balance_in_wallet) > 0;
                }

                return ((wallet.symbol.toLowerCase().includes(this.filter.search.toLowerCase()) ||
                    wallet.currency.toLowerCase().includes(this.filter.search.toLowerCase()))
                    && sortedBy);
            });


        },


        markets: function () {
            
            if (this.$store.getters.getMarkets.length === 0) {
            // If markets data is not available, fetch it
            this.$store.dispatch('fetchMarkets');
        }
            return this.$store.getters.getMarkets;
        },

	totalValueInUSDT: function () {
            return this.wallets.reduce((total, wallet) => {
                return total + this.calculateValueInUSDT(wallet);
            }, 0);
        }


    },


    methods: {
        // Calculate value of wallet in USDT
        calculateValueInUSDT(wallet) {
            
            const market = this.findMarketBySymbol(wallet.symbol + '-USDT');


	    if (wallet.symbol === 'USDT') {
                // If the symbol is USDT, just sum the balances
                const balanceInWallet = parseFloat(wallet.balance_in_wallet);
                const balanceInOrders = Math.abs(parseFloat(wallet.balance_in_order));
                const balanceInWithdraw = Math.abs(parseFloat(wallet.balance_in_withdraw));

                if (isNaN(balanceInWallet) || isNaN(balanceInOrders) || isNaN(balanceInWithdraw)) {
                    console.log('One or more values is not a number.');
                    return 0;
                }

                const totalBalance = Math.floor(balanceInWallet + balanceInOrders + balanceInWithdraw);
                console.log('Total balance in USDT:', totalBalance);
                return totalBalance;
             }




                
            if (market) {

                const balanceInWallet = parseFloat(wallet.balance_in_wallet);
                const balanceInOrders = Math.abs(parseFloat(wallet.balance_in_order));
                const balanceInWithdraw = Math.abs( parseFloat(wallet.balance_in_withdraw));
                const lastPrice = parseFloat(market.last);
                if (isNaN(balanceInWallet) || isNaN(balanceInOrders) || isNaN(balanceInWithdraw) || isNaN(lastPrice)) {
                    console.log('One or more values is not a number.');
		    return 0;
                }
                const value = Math.floor((balanceInWallet + balanceInOrders + balanceInWithdraw) * lastPrice);
                console.log('Value in USDT:', value);
        
                       
                
        
        return value;

	

            }
                
            return 0; // Default to 0 if market not found
        },
        // Find market by symbol
        findMarketBySymbol(symbol) {
            return this.markets.find(market => market.name === symbol);
        }
    }

})
</script>
